import request from '@/utils/request';
export function expireToken() {
    return request({
        url: '/expireToken',
        method: 'get',
    });
}
export function refreshToken() {
    // 后端 /auth/refresh 为 sliding expiration 模式，基于当前 access token 续签，
    // 不依赖 refreshToken 字段，故请求体为空（不发空串字段避免后端误判）
    return request({
        url: '/auth/refresh',
        method: 'post',
        data: {},
    });
}
